import axios from 'axios'
import endpoint from './config/endpoint';
import headers from './config/headers';
import unauthorized from './interceptors/unauthorized';

const api = (baseUrl, isPublic = false) => {
  const instance = axios.create({
    baseURL: endpoint.get(baseUrl),
    headers: headers(isPublic)
  });

  unauthorized(instance);

  return instance;
};

export default api;